<template>
  <SJCollapseTransition
    :duration="duration"
    :timingFunction="timingFunction"
    v-on="$listeners"
  >
    <div v-show="value">
      <slot></slot>
    </div>
  </SJCollapseTransition>
</template>

<script>
/**
 * transistion组件，使部分内容渐显或渐隐
 * slot为折叠的内容，需要外部控制value决定是否显示。
 * 具体transition方法参见collapse-transistion.js
 */
import SJCollapseTransition from "./collapse-transition";

export default {
  name: "SjCollapse",
  components: {
    SJCollapseTransition
  },
  props: {
    duration: {
      type: Number,
      default: 0.3
    },
    timingFunction: {
      type: String,
      default: "ease-in-out"
    },
    value: {
      type: Boolean
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
